import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const UsuarioList = ({ onEdit, onDelete,reloadTrigger  }) => {
    const [usuarios, setUsuarios] = useState([]);

    const fetchUsuarios = () => {
        fetch(`${config.apiUrl}/usuarios`)
            .then((res) => res.json())
            .then(setUsuarios)
            .catch(console.error);
    };

    useEffect(() => {
        fetchUsuarios(); // Cargar usuarios al inicio y cada vez que cambie reloadTrigger
    }, [reloadTrigger]);

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Lista de Usuarios </h2>
            <table className="table table-bordered table-striped table-dark">
                <thead className="thead-dark">
                <tr>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Tipo</th>
                    <th colSpan={2}  className="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {usuarios.map((usuario) => (
                    <tr key={usuario.usuario_id}>
                        <td>{usuario.nombre}</td>
                        <td>{usuario.correo}</td>
                        <td>{usuario.tipo_usuario}</td>
                        <td  className="text-center">
                            <button
                                className="btn btn-warning btn-sm mr-2"
                                onClick={() => onEdit(usuario)}
                            >
                                <FontAwesomeIcon icon={faEdit}/>

                            </button>
                        </td>
                        <td  className="text-center">
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDelete(usuario.usuario_id)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt}/>

                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default UsuarioList;
